module.exports = __webpack_public_path__ + "static/media/question_blur.6aed8e2b.png";